/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
import { Link } from "react-router-dom";
// Redux Toolkit
import { useSelector } from "react-redux";
import { selectUser } from "../../store/userSlice";
import authRoles from "../../auth/authRoles";
// BASE components
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
import useThemeMediaQuery from "../../../@BASE/hooks/useThemeMediaQuery";
// Material-UI components
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Typography from '@mui/material/Typography';
// Custom components
import EmptyVersionsCard from "../crud/instance/version/EmptyVersionsCard";

function POCCard({ instance}) {

  if (!instance) {
    return null;
  }

  return (
    <div className='w-full'>
      <div className="mb-32 space-y-16">
        <Typography className="grow text-2xl font-bold tracking-tight leading-none py-8">
          Points of Contact
        </Typography>
        <Divider />
        <Paper className="flex flex-col flex-auto p-24 shadow rounded-xl overflow-hidden">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <Typography className="text-lg font-medium tracking-tight leading-6 truncate">
                Contract Personnel
              </Typography>
              <Typography
                className="text-md font-medium"
                color="text.secondary"
              >
                Core Project Personnel
              </Typography>
            </div>
          </div>
          <List className="py-0 mt-8 divide-y">
            <ListItem
              className="px-0"
            >
              <ListItemText
                classes={{ primary: 'font-medium text-md' }}
                primary="Program Manager"
                secondary={
                  <span className="flex flex-col sm:flex-row sm:items-center -ml-2 mt-8 sm:mt-4 space-y-4 sm:space-y-0 sm:space-x-12">
                    {instance.manager && (
                      <span className="flex items-center">
                        <BASESvgIcon
                          size={20}
                        >
                          heroicons-outline:user
                        </BASESvgIcon>
                        <Typography
                          component="span"
                          className="mx-6 text-sm"
                          color="text.secondary"
                        >
                          {instance.manager.first_name} {instance.manager.last_name}
                        </Typography>
                      </span>
                    )}
                  </span>
                }
              />
            </ListItem>
            <ListItem
              className="px-0"
            >
              <ListItemText
                classes={{ primary: 'font-medium text-md' }}
                primary="Client"
                secondary={
                  <span className="flex flex-col sm:flex-row sm:items-center -ml-2 mt-8 sm:mt-4 space-y-4 sm:space-y-0 sm:space-x-12">
                    {instance.client && (
                      <span className="flex items-center">
                        <BASESvgIcon
                          size={20}
                        >
                          heroicons-outline:user
                        </BASESvgIcon>
                        <Typography
                          component="span"
                          className="mx-6 text-sm"
                          color="text.secondary"
                        >
                          {instance.client.first_name} {instance.client.last_name}
                        </Typography>
                      </span>
                    )}
                  </span>
                }
              />
            </ListItem>
            <ListItem
              className="px-0"
            >
              <ListItemText
                classes={{ primary: 'font-medium text-md' }}
                primary="Contract Officer"
                secondary={
                  <span className="flex flex-col sm:flex-row sm:items-center -ml-2 mt-8 sm:mt-4 space-y-4 sm:space-y-0 sm:space-x-12">
                    {instance.cor && (
                      <span className="flex items-center">
                        <BASESvgIcon
                          size={20}
                        >
                          heroicons-outline:user
                        </BASESvgIcon>
                        <Typography
                          component="span"
                          className="mx-6 text-sm"
                          color="text.secondary"
                        >
                          {instance.cor.first_name} {instance.cor.last_name}
                        </Typography>
                      </span>
                    )}
                  </span>
                }
              />
            </ListItem>
          </List>
        </Paper>
      </div>
    </div>
  )
}

export default POCCard;
